<template>
    <div class="user-info">
        <!-- 头像 问候语 -->
        <div class="avatar">
            <div class="avatar-left"></div>
            <div class="avatar-right">
                <p>{{ userInfo.dailyGreeting }}</p>
                <p class="speech" :title="userInfo.speech">{{ userInfo.speech }}</p>
            </div>
        </div>
    </div>

</template>
<script>
import axios from 'axios';

export default {
    name: 'UserInfo',
    data() {
        return {
            user: {},
            supplierInfo: {},
            // 登录人信息框
            userInfo: {
                dailyGreeting: '',
                speech: '',
            },
        };
    },
    methods: {
        // 获取节日祝福语
        getSlogan() {
            axios.post('/srmbase/basePersonConf/savePersonConf', {
                langType: this.$i18n.locale,
            })
                .finally(() => {
                    setTimeout(() => {
                        axios.get('/srmbase/workbench/getSloganForGsC').then((res) => {
                            const resp = res.data.data;
                            if (resp.status === 0) {
                                this.userInfo.speech = resp.data.festivalGreeting || '';
                                this.userInfo.dailyGreeting = resp.data.dailyGreeting || '';
                            } else {
                                this.userInfo.speech = '日子常新，未来不远';
                            }
                        });
                    }, 1000);
                });
        },
    },
    mounted() {
        this.user = JSON.parse(localStorage.getItem('user'));
        this.supplierInfo = JSON.parse(localStorage.getItem('supplierInfo'));
        this.userInfo.dailyGreeting = `你好，${this.user.name}`;
        this.getSlogan();
    },
};
</script>
<style lang='less' scoped>
.user-info {
    position: relative;
    padding: 0 0 0 50px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    background: url("../../../../../assets/home/banner.png") no-repeat 55% 140% / auto 100%,
                url("../../../../../assets/home/bannerWhiteBg.png") no-repeat left top / auto 100%,
                linear-gradient(180deg, #378FFF 0%, #1E61FF 100%);

    .avatar {
        display: flex;
        .avatar-left {
            min-width: 70px;
            height: 70px;
            border-radius: 50%;
            background: transparent url("../../../../../assets/home/avatar.jpg") no-repeat center center / 110% 110%;
            margin-right:16px;
        }
        .avatar-right {
            flex: 0 0 168px;
            color: #FFFFFF;
            p:nth-child(1) {
                text-align: left;
                font-weight: 500;
                font-size: 20px;
                margin-bottom: 10px;
            }
            p:nth-child(2) {
                text-align: left;
                font-size: 14px;
                font-weight: 100;
                max-width:268px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
            }
        }
    }
    .credit {
        color: #FFFFFF;
        margin-right: 40px;
        font-size: 14px;
        .credit-content0 {
            font-weight: bold;
            font-style: italic;
            text-align: center;
            margin-bottom: 5px;
        }
        .credit-content1 {
            font-weight: 100;
            text-align: right;
            display: inline-block;
        }
        .credit-content2 {
            display: inline-block;
            font-weight: 400;
            text-align: left;
        }
        .credit-content3 {
            font-weight: 200;
            font-size: 8px;
            text-align: right;
            color: #ececec;
        }
        .credit-content4 {
            cursor: pointer;
            position: absolute;
            right: 20px;
            bottom: 8px;
            font-weight: 100;
            font-size: 12px;
            .icon-common {
                transform: scaleX(-1);
            }
        }
        .credit-content5 {
            font-weight: bold;
            font-style: italic;
            text-align: center;
            margin-top: 5px;
        }
        .small-font {
            font-size: 10px;
        }
    }

    .credit-version1 {
        cursor: pointer;
        color: #FFFFFF;
        margin-right: 60px;
        text-align: center;
        height: 100%;
        padding-top: 27px;
        .credit-content1 {
            font-size: 13px;
            font-weight: 200;
            margin-bottom: 22px;
            height: 18px;
        }
        .credit-content2 {
            height: 32px;
            display: inline-block;
            opacity: 0.78;
            background: #1E61FF;
            border-radius: 16px;
            padding: 8px 32px;
            font-size: 12px;
            letter-spacing: 0.38px;
            font-weight: 400;
            margin-bottom: 6px;
            span {
                margin-right: 20px;
            }
        }
        .credit-content3 {
            font-size: 12px;
            font-weight: 200;
        }
    }
}

</style>
